<template>

  <ChartContainer
    :value="current"
    :type="type"
    :lastChart="lastChart"
    :nextChart="nextChart">

    <component
      ref="currentChart"
      v-if="showHolder && showHolder.showType"
      :is="controlNameMap[showHolder.showType]"
      :current="current"
      :showPropertiesHolder="showHolder"
      :type="type">
    </component>
  </ChartContainer>
</template>

<script>
  import ChartContainer from './common/container'
  import ControlCustomChart, {controlNameMap} from '../control/CustomChart/index'
  export default {
    name: "CustomChart",
    props: {
      value: Object,
      type: Number,
      nextChart: Function,
      lastChart: Function
    },
    components: {
      ChartContainer,
      ...ControlCustomChart
    },
    data() {
      return {
        controlNameMap,
        current: this.value,
        showHolder: this.value.showPropertiesHolder,
      }
    },
    created() {


    },
    methods: {

      resize() {
        const current = this.$refs.currentChart
        if (current && current.resize) {
          current.resize()
        }
      },
      initChart() {
        const current = this.$refs.currentChart
        if (current && current.initChart) {
          current.initChart()
        }
      },
    }
  }
</script>

<style scoped>

</style>
